import {
	Component
} from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../animations/page-transitions';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { BackButtonComponent } from '../back-button/back-button.component';

import { EaqdbWidgetComponent } from './eaqdb-widget.component';
import { GuaranteeRequestWidgetComponent } from './guarantee-request-widget.component';
import { ClaimRequestWidgetComponent } from './claim-request-widget.component';
import { AuctionWidgetComponent } from './auction-widget.component';

@Component({
	selector: 'copo-quality-services-menu',
	templateUrl: './quality-services-menu.component.html',
	animations: pageTransitions,
	imports: [
		BackButtonComponent,
		TranslateModule,
		NgIf,
		AuctionWidgetComponent,
		ClaimRequestWidgetComponent,
		GuaranteeRequestWidgetComponent,
		EaqdbWidgetComponent
	]
})

export class QualityServicesMenuComponent {
	user: User;
	constructor(
		private readonly userService: UserService,
	) {
		this.user = this.userService.user;
	}

	hasRaiseIssueService() {
		return this.user.hasService('QUAPP') && (this.user.isClaimDetector() || this.user.isClaimValidator());
	}

	hasGuaranteeService() {
		return this.user.hasService('PGNTE');
	}
}
